var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('scanner-qr-form',{attrs:{"qr-type":'glass-move-qr'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }